import { createApp } from 'vue';
import Antd from 'ant-design-vue';
/**
 * 
 * 부트스트랩 리팩토링 하면서 삭제해야 할 파일
 */
import 'bootstrap/dist/js/bootstrap.js';
import 'bootstrap/dist/css/bootstrap.css';
/**
 * 
 * 부트스트랩 리팩토링 하면서 삭제해야 할 파일 끝
 */

import Vue3ColorPicker from 'vue3-colorpicker';
import VueDatePicker from '@vuepic/vue-datepicker';
import EllipsisCell from '@/components/EllipsisCell.vue';

import App from './App.vue';
import store from './store';
import router from './router';
import i18n from './i18n'

import 'ant-design-vue/dist/reset.css';
import 'vue3-colorpicker/style.css';
import '@vuepic/vue-datepicker/dist/main.css'

import CssLoader from './css-loader';
import './assets/css/nucleo-icons.css';
import './assets/css/nucleo-svg.css';
// a-tour 팝업 폭 520px 고정 → 모바일 뷰포트 초과 보정 (전 화면 공용, .ant-tour 하위만 스코프)
import './assets/css/tour-mobile.css';

// Hotjar
// import Hotjar from '@hotjar/browser';
// const siteId =  process.env.VUE_APP_HOTJARID;
// const hotjarVersion = 6;
//
// Hotjar.init(siteId, hotjarVersion);

const app = createApp(App);

app.component('VueDatePicker', VueDatePicker);
app.component('EllipsisCell', EllipsisCell);

app.use(store);
app.use(router);
app.use(i18n);
app.use(Antd)
app.use(Vue3ColorPicker)
app.use(CssLoader);
// 한국 inapi(apiInstance/$apiInstance) 전역 배선은 2026-08-05 제거 — 사용처 0건 실측.
// 모든 API 는 src/apis/chinaInapi.js(VUE_APP_CHINA_INAPI_URL) 경유가 정본이다.

// REQ-LOCALE-FE-004: app boot 시 localStorage backup 즉시 적용 (login 응답 이전)
// boot flash 방지를 위해 mount 전 i18n+lang 직접 설정 (Vue 렌더 첫 frame 부터 정확)
const _BOOT_SUPPORTED = ['ko', 'zh'];
const _bootLocale = localStorage.getItem('admin_china_locale');
const _initialLocale = (_BOOT_SUPPORTED.includes(_bootLocale)) ? _bootLocale : 'zh';
// REQ-LOCALE-FE-001: composition mode .value 규약
i18n.global.locale.value = _initialLocale;
// REQ-LOCALE-FE-011: html lang 동기 갱신
document.documentElement.lang = _initialLocale;

app.mount('#app');

// FE-D1 patch: mount 후 Vuex state 채널 동기화 (5채널 일관 — LocaleSwitcher currentLocale invariant)
// SPEC-CHINA-ADMIN-LOCALE-CORE-001 expert-frontend ANALYZE 결과
store.dispatch('locale/applyLocale', { source: 'localStorage' }).catch((e) => {
    // boot 단계 실패는 silent (i18n/lang은 이미 위에서 직접 설정됨)
    console.warn('[locale] boot applyLocale failed:', e);
});
